module.exports = __webpack_public_path__ + "img/clogo.a1f20d0f.png";